/* Component used for the banner at the very top of the header */

import styles from "../Header.module.scss";
import { useSelector } from "react-redux";
import { attentiveIdentifyCustomer } from "@/components/common/Attentive";
import { isIOS } from "react-device-detect";
import { useEffect } from "react";
import { useRouter } from "next/compat/router";
import { useState } from "react";
import  HeaderGlobalBanner  from "@/components/BuilderIO/GlobalBanner/GlobalBanner.builder";

function TopBanner({ isMobile = false, topLinks, accountSidebar, selectedIcon, handleSetAccountColor }) {
  const router = useRouter()

  const logUser = useSelector((state) => state.loginUser);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const userEmail = logUser?.userData?.email;
  const nostoPlacements = [];//useSelector((state) => state.nosto.nostoPlacements);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const [isRewards, setIsRewards] = useState(false);
  const lowerHeaderZIndex = useSelector((state) => state.header.lowerHeaderZIndex);
  const [headerColor,setHeaderColor]=useState(null)

  useEffect(()=>{
    if (router.asPath.startsWith("/rewards")) {
      setIsRewards(true);
    }
    else {
      setIsRewards(false);
    }
  },[router]);

  useEffect(()=>{
    if(handleSetAccountColor){
      handleSetAccountColor(headerColor);
    }
  },[headerColor])

  useEffect(() => {  
      const themeColorMetaTag = document.querySelector('meta[name="theme-color"]');
      if(themeColorMetaTag){
        themeColorMetaTag.setAttribute('content',headerColor? headerColor.background : '#C5D3E2');
      } else {
        const newMetaThemeColor = document.createElement('meta');
        newMetaThemeColor.name = 'theme-color';
        newMetaThemeColor.content = headerColor? headerColor.background : '#C5D3E2';
        document.head.appendChild(newMetaThemeColor);
      }
  },[headerColor])

  if (!isMobile) {
    return (
      <section className={`mob_hide ${styles.top_header} ${lowerHeaderZIndex ? styles.no_overlap : ""}`}
      style={{
        backgroundColor:headerColor? headerColor.background : '#C5D3E2',
      }}
      >
        <div className="container-fluid mw-1440">
          <div className="row">
            <div className="grid-md-3 grid-sm-3">{topLinks}</div>
            <div
              className="grid-md-6 grid-sm-6 text-center"
              onClick={() => attentiveIdentifyCustomer(userEmail)}
            >
              <HeaderGlobalBanner setHeaderColor={setHeaderColor} color={headerColor?.fontColor}/>
              {/* <div
                className="x-small-md x-small-sm x-small-xs nosto_element"
                id="promotional-msg"
                dangerouslySetInnerHTML={{
                  __html: nostoPlacements["promotional-msg"]
                    ? nostoPlacements["promotional-msg"]
                    : "ENJOY <strong>20% OFF</strong> YOUR FIRST APP PURCHASE WITH <strong>APP20</strong> (exclusions apply)",
                }}
                tabIndex={0}
              ></div> */}
            </div>
            <div className={`grid-md-2 grid-sm-2 ${styles.top_left} position_relative ${
                      selectedIcon == "user-account" ? "selected" : ""
                    } ${accountSidebarOpen? 'set_open' : ''}`}>
              <span className={`normal-md ${isRewards && "active" }`} style={{color:headerColor?.fontColor}}>
                <a tabIndex={0} href="/rewards" className="header-rewards auto-rewards">Rewards</a>
              </span>
              <span className="normal-md acc-separator" style={{color:headerColor?.fontColor}}> | </span>
              {accountSidebar}
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section className={`desk_hide ${styles.mobile_header_top} ${isPWA ? "addTopPadding":""}` } 
      style={{
        backgroundColor:headerColor? headerColor.background : '#C5D3E2',
        color:headerColor?.fontColor
      }}>
        <div className="container-fluid">
          <div className="row">
            <div
              className="grid-xs-10 grid-sm-10 grid-md-10 text-center"
              onClick={() => attentiveIdentifyCustomer(userEmail)}
            >
              <HeaderGlobalBanner setHeaderColor={setHeaderColor}/>

              {/* <div
                className={`x-small-sm x-small-xs ${styles.promo_message} nosto_element`}
                id="promotional-msg-mob"
                dangerouslySetInnerHTML={{
                  __html: nostoPlacements["promotional-msg-mob"]
                    ? nostoPlacements["promotional-msg-mob"]
                    : "<strong>20% OFF</strong> YOUR FIRST APP ORDER*",
                }}
              ></div> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TopBanner;
